import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import student from './modules/student'
import teacher from './modules/teacher'
import eum from './modules/eum'
import banner from './modules/banner'
import dealcheck from './modules/dealcheck'
import graduates from './modules/graduates'
import inform from './modules/inform'
import bookver from './modules/bookver'
import resour from './modules/resour'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    user,
    student,
    teacher,
    eum,
    banner,
    dealcheck,
    graduates,
    inform,
    bookver,
    resour
  },
  getters
})

export default store
